/** Map known API validation errors without exposing raw server messages. */
export const getDisplayNameErrorTextId = (error: unknown) => {
  if (error instanceof Error) {
    // SocketAsFetch rejects with the serialized error response as its message.
    try {
      const response = JSON.parse(error.message);
      const reason = response?.info?.reason;

      if (
        typeof reason === 'string' &&
        /^(?:invalid_request: )?error validating preferred first name: invalid character: /i.test(
          reason,
        )
      ) {
        return 'STR_DISPLAY_NAME_INVALID_CHARACTERS';
      }
    } catch {
      // Network and unexpected errors use the localized name-save fallback.
    }
  }

  return 'STR_DISPLAY_NAME_UPDATE_FAILED';
};
